export default "__VITE_ASSET__WFhjNw8P__"